import Patient from '../script/Patient.js'
import Connexion from '../script/Connexion.js'
import Prat from '../script/Prat.js'
import Contrat from '../script/Client.js'

export default {
    namespaced: true,

    state() {
        return {
            lesPrat: localStorage.lesPrat,
            pratCourant: localStorage.pratCourant,
            lesProd: localStorage.lesProd,
            lesMod: localStorage.lesMod,
            contrat: localStorage.contrat
        }
    },
    getters: {
        getPratCourant(state) {
            return state.pratCourant;
        },
        getLesPrat(state) {
            return state.lesPrat;
        },
        getLesProd(state) {
            return state.Prod;
        },
        getLesMod(state) {
            return state.lesMod;
        },
        getContrat(state) {
            return state.contrat;
        }
    }
    ,
    mutations: {
        setLesPratBySearch(state, lesPrat) {
            state.lesPrat = lesPrat;
        },
        setPratCourant(state, prat) {
            state.pratCourant = prat
        },
        
        setLesProd(state, lesProd) {
            state.lesProd = lesProd;
        },
        setLesMod(state, lesMod) {
            state.lesMod = lesMod;
        },
        setLesModByProd(state, lesMod) {
            state.lesMod = lesMod;
        },
        setContrat(state, contrat) {
            console.log(contrat);
            alert("flic32.js setContrat")
            state.contrat = contrat;
        }
    },

    actions: {
        setLesPratBySearch({ commit, state }, critere) {

            if (critere == null || critere == "")
                critere = "a";
            const lesPrat = Prat.getPratBySearch(critere);
            lesPrat.then(response => {
                commit("setLesPratBySearch", response);
            })
        },
        setPratCourant({ commit, state }, id) {
            const prat = Prat.getPratById(id);
            prat.then(response => {
                commit("setPratCourant", response);
            });
        },
        setLesProd({ commit, state} , lesProd) {
            var lesProd = Prat
        },
        setLesModByProd({commit ,state } , prod) {
            const lesMod = Prat.getLesModByProd(prod)
            lesMod.then(response => {
                commit("setLesModByProd", response)
            });
        },

        //obj est de type {NOM_PRAT : string, PRODUIT : string}
        setPratCourantByNameAndProd({ commit, state }, obj) {
            Prat.getPratByNameAndProd(obj.NOM_PRAT, obj.PRODUIT)
                .then(response => {
                    console.log("setPratCourant: ", response);
                    commit("setPratCourant", response);
                } )
        },
        setContratById({ commit }, id) {
            Contrat.getContratById(id)
                .then(response => {
                    if(id!= null)
                        commit('setContrat', response);
                })
        }
        
        
    }
}


